import React, 
       { useState, 
         useEffect, 
         useRef,
                                      }     from "react";
import { DisplayGridDatetime          }     from "components/Date/date";
import { AgGridReact                  }     from "ag-grid-react";
import { AllCommunityModule,
         ModuleRegistry               }     from 'ag-grid-community';
import { AG_GRID_LOCALE_BR            }     from '@ag-grid-community/locale';
import { useLoader                    }     from "components/Covers/loadingCover";
import { useActionModal}                    from "components/Covers/confirmAction";
import { useInfoMsgModal}                   from "components/Covers/infoMessageModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { InputGeneral                 }     from "components/Field/field";
import { DatePicker,
         DateToIsoString,
         DateFromIsoString,
         InitDateToIsoString,
         InitDateFromIsoString,
         setDefaultInitDate,
         setDefaultFinalDate,
         compareInitFinDate }               from "components/Date/date";
import  MainStyle                           from "components/UI/main.module.scss";
import { useNavigate                  }     from "react-router-dom";
import { Select, 
         Checkbox, 
         Divider                      }     from "antd"; 
import { DefaultLoadingLogo,
         Heimdall,
         GetLabel,
         SetLastFeature,
         GetAppLang,                  }     from "Utilities/utils";
import { getData, 
         getFilterMeta,
         rgetData,
         rgetFilterMeta,
         getPivotConfigTemplate,
         updatePivotConfigTemplate,
         deletePivotConfigTemplate    }     from "./Report_Service";
import   PivotTable                         from "./PivotTable";


// #region Object Template
let blank_search_param_obj  = {
    DT_INIT           : DateToIsoString(setDefaultInitDate()),
    DT_FN             : DateToIsoString(setDefaultFinalDate()),
    SCHOOL_IDS        : [],
    AREA_IDS          : [],
    PROGRAM_IDS       : [],
    CLIENT_IDS        : [],
    ACADEMIC_AREA_IDS : [],
    USER_IDS          : [],
    QUESTION_IDS      : [],
    APP_LANG          : GetAppLang(),
};
let blank_meta_param_obj    = {
    SCHOOL_LIST       : [],
    AREA_LIST         : [],
    PROGRAM_LIST      : [],
    CLIENT_LIST       : [],
    ACADEMIC_AREA_LIST: [],
    USER_LIST         : [],
    QUESTION_LIST     : [],
};
let blank_filter_param_obj  = {
    TEMPLATE_ID: 0,
    TEMPLATE_DESC: "",
    TEMPLATE_PUBLIC_DESC: "",
    TEMPLATE_DATA: {
        PT: {},
        EN: {},
        ES: {},
    },
    PUBLISHED: 0
};
let blank_filter_param_list  = {
    PERSONAL: [],
    PUBLIC: []
};
let appLang = GetAppLang();
// #endregion

// #region Layout Helppers
const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
}) => {
    const selectedValues = Array.isArray(value) ? value : [];
    const allValues = listOfItems.map(item => item.value);

    const allSelected = selectedValues.length === allValues.length;

    const handleSelectAll = (checked) => {
        onChange?.(checked ? allValues : []);
    };
    
    return (
        <Select
            mode="multiple"
            showSearch
            allowClear
            id={id}
            name={name}
            value={value}
            placeholder={placeholder}
            className={className}
            style={style}
            title={title}
            popupClassName={popupClassName}
            options={listOfItems}
            optionFilterProp="label"
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            onChange={(val, option) => {
                onChange?.(val, option);
            }}
            onSearch={(val) => {
                onSearch?.(val);
            }}
            notFoundContent={null}
            dropdownRender={(menu) => (
                <>
                <div style={{ padding: 8 }}>
                    <Checkbox
                        checked={allSelected}
                        indeterminate={
                            selectedValues.length > 0 &&
                            selectedValues.length < allValues.length
                        }
                        onChange={(e) => handleSelectAll(e.target.checked)}
                        className={MainStyle.text_body}
                    >
                        {GetLabel(appLang, 608)}
                    </Checkbox>
                </div>
                <Divider style={{ margin: "8px 0" }} />
                {menu}
                </>
            )}            
        />
    );
};
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
//#endregion

// #region Drawer
const AccordionIcon = React.memo(({...props}) => {
    const { direction, value } = props;
    return (
        <>
            {direction === "X" && (                
                value ?
                    (<path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z"/>)                    
                :
                    (<path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>)
            )}
            {direction === "Y" && (
                value ?
                    (<path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>)
                :
                    (<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>)
                
            )}            
        </>            
    );
});
const DrawerY = React.memo(({children, objProp, defaultExpanded = false}) => {
    const [ expanded, setExpanded   ] = useState(defaultExpanded);
    const [ height,   setHeight     ] = useState(defaultExpanded ? "auto" : "0px");
    const [ overflow, setOverflow   ] = useState(defaultExpanded ? "auto" : "hidden");
    const intervalRef                 = useRef(null);

    useEffect(() => {
        if (defaultExpanded) openDrawer();
        else closeDrawer();
    }, [defaultExpanded]);

    const openDrawer = () => {
        const content = intervalRef.current;
        if (!content) return;

        setExpanded(true);
        setOverflow("hidden");

        const scrollHeight = content.scrollHeight;
        setHeight(scrollHeight + "px");

        setTimeout(() => {
            setHeight("auto");
            setOverflow("auto");
        }, 300);
    };

    const closeDrawer = () => {
        const content = intervalRef.current;
        if (!content) return;

        const scrollHeight = content.scrollHeight;

        setHeight(scrollHeight + "px");
        setOverflow("hidden");

        requestAnimationFrame(() => {
            setHeight("0px");
        });

        setTimeout(() => {
            setExpanded(false);
        }, 300);
    };

    const handleClick = () => {
        if (expanded) closeDrawer();
        else openDrawer();
    };


    return (
        <div className={[MainStyle.shadow_sm, MainStyle.rounded].join(" ")}>
            <div
                className={[MainStyle.d_flex, MainStyle.border_bottom, MainStyle.rounded_top, MainStyle.clickable].join(" ")}
                onClick={handleClick}
            >
                <div className={[ MainStyle.align_self_center]}>
                    <span className={[MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                        {objProp.drawerLabel}
                    </span> 
                </div>
                <div className={[MainStyle.ms_auto].join(" ")}>
                    <div 
                        className={[MainStyle.shadow_sm, MainStyle.rounded_top, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_3, MainStyle.ms_1].join(" ")}>
                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                            <AccordionIcon direction={"Y"} value={expanded}/>
                        </svg>
                    </div>
                </div>
            </div>
            <div
                ref={intervalRef}
                style={{
                    height,
                    overflowY: overflow,
                    transition: "height 300ms ease",
                }}
                className={[MainStyle.bg_theme].join(" ")}
            >
                {expanded && children}
            </div>
        </div>
    );

});
const DrawerX = React.memo(({ children, expanded, onToggle }) => {
    return (
        <>
            <div onClick={onToggle}
                className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_3, MainStyle.align_self_center].join(" ")}>
                <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                    <AccordionIcon direction={"X"} value={expanded}/>
                </svg>
            </div>
            {expanded && (
                <div className={[MainStyle.bg_theme, MainStyle.shadow_sm, MainStyle.border_1].join(" ")}>
                    {children}
                </div>
            )}
        </>
    );

});
// #endregion

// #region Filter Data
const FilterOptions = React.memo(({...props}) => {
    const { searchMetaParam,
            searchParam,
            setSearchParam,
            getData,
            showInfoMessage  }      = props;

    useEffect(() => {},[searchMetaParam, searchParam]);
    
    return (
        <>
            {searchMetaParam ? (
                <React.Fragment>
                    {/*     Dates Selector    */}         
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_start, MainStyle.align_items_center, MainStyle.mx_3, MainStyle.my_1].join(" ")}>
                        <div className={[MainStyle.d_flex, MainStyle.flex_column].join(" ")}>
                            <div className={[MainStyle.clickable, MainStyle.ico_svg].join(" ")} 
                                 style={{ width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}
                                 onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 621)});}}
                            >
                                <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                    <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                </svg>
                            </div>
                        </div>
                        <div className={[MainStyle.d_flex, MainStyle.flex_column].join(" ")}>
                            <div className={MainStyle.m_1}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 236)}
                                </span>                      
                                <DatePicker
                                    value={InitDateFromIsoString(searchParam.DT_INIT)}
                                    placeholder={GetLabel(appLang, 487)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_INIT: InitDateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>                            
                        </div>
                        <div className={[MainStyle.d_flex, MainStyle.flex_column].join(" ")}>
                            <div className={MainStyle.m_1}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 237)}
                                </span>
                                <DatePicker
                                    value={DateFromIsoString(searchParam.DT_FN)}
                                    placeholder={GetLabel(appLang, 488)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_FN: InitDateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>                            
                        </div>
                    </div>
                    {/*  Get Data Button      */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_center, MainStyle.m_3].join(" ")}>
                                <button onClick={() => {getData(searchParam);}}
                                        style={{ width: '100%' }}
                                        className={[MainStyle.text_center,
                                                    MainStyle.btn_blue, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.text_white,
                                                    MainStyle.rounded_3].join(" ")} 
                                >
                                    <div className={[MainStyle.my_3].join(" ")}>
                                        <span>{GetLabel(appLang, 554)}</span>
                                    </div>
                                </button>                                
                            </div>
                        </div>
                    </div>
                    {/*         School        */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 318)}
                                                </span>
                                                <DropdownList
                                                    value={searchParam?.SCHOOL_IDS}
                                                    placeholder={GetLabel(appLang, 379)}
                                                    listOfItems={
                                                        searchMetaParam?.SCHOOL_LIST?.map((i) => ({
                                                            value: i.SCHOOL_ID,
                                                            label: i.SCHOOL_DESC
                                                        }))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(valueArray) => {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            SCHOOL_IDS: valueArray
                                                        }));
                                                    }}
                                                />                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*          Area         */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 319)}
                                                </span>
                                                <DropdownList
                                                    value={searchParam?.AREA_IDS}
                                                    placeholder={GetLabel(appLang, 380)}
                                                    listOfItems={
                                                        searchMetaParam?.AREA_LIST?.map((i) => ({
                                                            value: i.AREA_ID,
                                                            label: i.AREA_DESC
                                                        }))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(valueArray) => {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            AREA_IDS: valueArray
                                                        }));
                                                    }}
                                                />                                             
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                    {/*        Program        */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 321)}
                                                </span>
                                                <DropdownList
                                                    value={searchParam?.PROGRAM_IDS}
                                                    placeholder={GetLabel(appLang, 381)}
                                                    listOfItems={
                                                        searchMetaParam?.PROGRAM_LIST?.map((i) => ({
                                                            value: i.PROGRAM_ID,
                                                            label: i.PROGRAM_DESC
                                                        }))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(valueArray) => {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            PROGRAM_IDS: valueArray
                                                        }));
                                                    }}
                                                />                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*        Client         */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 322)}
                                                </span>
                                                <DropdownList
                                                    value={searchParam?.CLIENT_IDS}
                                                    placeholder={GetLabel(appLang, 382)}
                                                    listOfItems={
                                                        searchMetaParam?.CLIENT_LIST?.map((i) => ({
                                                            value: i.CLIENT_ID,
                                                            label: i.CLIENT_DESC
                                                        }))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(valueArray) => {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            CLIENT_IDS: valueArray
                                                        }));
                                                    }}
                                                />                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                    {/*     Academic Area     */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 323)}
                                                </span>
                                                <DropdownList
                                                    value={searchParam?.ACADEMIC_AREA_IDS}
                                                    placeholder={GetLabel(appLang, 522)}
                                                    listOfItems={
                                                        searchMetaParam?.ACADEMIC_AREA_LIST?.map((i) => ({
                                                            value: i.ACADEMIC_AREA_ID,
                                                            label: i.ACADEMIC_AREA_DESC
                                                        }))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(valueArray) => {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            ACADEMIC_AREA_IDS: valueArray
                                                        }));
                                                    }}
                                                />                                                   
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>        
                    {/*         Question      */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 79)}
                                                </span>
                                                <DropdownList
                                                    value={searchParam?.QUESTION_IDS}
                                                    placeholder={GetLabel(appLang, 208)}
                                                    listOfItems={
                                                        searchMetaParam?.QUESTION_LIST?.map((i) => ({
                                                            value: i.QUESTION_ID,
                                                            label: i.QUESTION_DESC
                                                        }))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(valueArray) => {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            QUESTION_IDS: valueArray
                                                        }));
                                                    }}
                                                />                                                   
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                    {/*         Users         */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.border_bottom}>
                                <div className={MainStyle.my_2}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_lg}>
                                            <div className={[MainStyle.mx_3].join(" ")}>
                                                <span className={[MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                    {GetLabel(appLang, 81)}
                                                </span>
                                                <DropdownList
                                                    value={searchParam?.USER_IDS}
                                                    placeholder={GetLabel(appLang, 208)}
                                                    listOfItems={
                                                        searchMetaParam?.USER_LIST?.map((i) => ({
                                                            value: i.USER_ID,
                                                            label: i.FULL_NAME
                                                        }))
                                                    }
                                                    style={{ width: "100%" }}
                                                    className={[MainStyle.mt_2].join(" ")}
                                                    onChange={(valueArray) => {
                                                        setSearchParam(prevState => ({
                                                            ...prevState,
                                                            USER_IDS: valueArray
                                                        }));
                                                    }}
                                                />                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>             
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_vanilla, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.text_body,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={async () => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_INIT: DateToIsoString(setDefaultInitDate()),
                                                DT_FN: DateToIsoString(setDefaultFinalDate()),
                                                STATUS_IDS        : [4],
                                                SCHOOL_IDS        : [],
                                                AREA_IDS          : [],
                                                PROGRAM_IDS       : [],
                                                CLIENT_IDS        : [],
                                                ACADEMIC_AREA_IDS : [],
                                                USER_IDS          : [],
                                                QUESTION_IDS      : []
                                            });
                                        });
                                    }}
                                >
                                    {GetLabel(appLang, 239)}
                                </button>
                            </div>
                        </div>                            
                    </div>
                </React.Fragment>

            )
            :
            (
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div style={{height: '10rem'}} className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_5].join(" ")}>
                            <div style={{zIndex: "1"}} className={[MainStyle.small_loading_circle].join(" ")}/>
                        </div>
                    </div>
                </div>
            )}
            {[...Array(3)].map((_, index) => (
                <DefaultPadding key={index} />
            ))}
        </>
    );

});
// #endregion

const GenericGrid = React.memo(({...props}) => {
    const { rowData,
            defsColumn                      }   = props;
    const [ columnDefs, setcolumnDefs       ]   = useState(null);      // Searched text state
    const [ searchText, setSearchText       ]   = useState('');      // Searched text state
    const gridRef                               = useRef();
    

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true,
    };
    
    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        if (defsColumn) {
            setcolumnDefs(defsColumn);
        }        
    },[rowData]);

    return (
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: "100%",
                    height: "600px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    );
});

const ExportData = React.memo(({...props}) => {
    const { type,
            searchMetaParam,
            searchParam,
            setSearchParam,
            setPivotRowData,
            setTableRowData,
            setExpandedDrawer                   } = props;
    const { showInfoMessage                     } = useInfoMsgModal();
    const { showLoader,         hideLoader      } = useLoader();
    const { showToastMessage                    } = useToastMessage();

    function extractTextQuestion(data) {
        let dataSet = [];
        for(let i = 0; i < data.length; i++) {
            if (data[i].QUESTION_TYPE_ID === 2) {
                dataSet.push({
                    ORDER_DESC            : data[i].ORDER_DESC            ,
                    SCHOOL_DESC           : data[i].SCHOOL_DESC           ,
                    AREA_DESC             : data[i].AREA_DESC             ,
                    CLIENT_DESC           : data[i].CLIENT_DESC           ,
                    PROGRAM_DESC          : data[i].PROGRAM_DESC          ,
                    CLASS                 : data[i].CLASS                 ,
                    OPENING               : data[i].OPENING               ,
                    CLOSING               : data[i].CLOSING               ,
                    SESSION_ORDER         : data[i].SESSION_ORDER         ,
                    ACADEMIC_AREA_DESC    : data[i].ACADEMIC_AREA_DESC    ,
                    EVOLVEDS              : data[i].EVOLVEDS              ,
                    QUESTION_DESC         : data[i].QUESTION_DESC         ,
                    QUESTION_TYPE_DESC    : data[i].QUESTION_TYPE_DESC    ,
                    QUESTION_LBL_DESC     : data[i].QUESTION_LBL_DESC     ,
                    SUBMISSION_DT         : data[i].SUBMISSION_DT         ,
                    ANSWER_VALUE          : data[i].ANSWER_VALUE          ,
                    OBSERVATION           : data[i].OBSERVATION           ,
                    OPT                   : data[i].OPT                   ,
                    OPTION_VALUE          : data[i].OPTION_VALUE          ,
                });
            }
        }
        return(dataSet);
    }

    async function GetDataSet(obj) {
        if (!compareInitFinDate(searchParam.DT_INIT, searchParam.DT_FN)) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 230)});
            return;
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let data = null;
        if (type === 1) {
            data = await getData(obj);
        }
        else {
            data = await rgetData(obj);
        }
        if (data) {
            if (data?.status?.statusCode == 0) {
                data = data.response.content;
                setTableRowData(extractTextQuestion(data));
                setPivotRowData(data);
                hideLoader();
                showToastMessage({
                    'header': GetLabel(appLang, 54), 
                    'message': GetLabel(appLang, 538)
                });
                setExpandedDrawer(true);
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
            }
        }
        else {
            hideLoader();
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
        }
    }

    useEffect(() => {
    },[searchMetaParam, searchParam]);

    return (
        <div className={MainStyle.shadow}>
            <FilterOptions 
                searchMetaParam={searchMetaParam}
                searchParam={searchParam}
                setSearchParam={setSearchParam}
                getData={GetDataSet}
                showInfoMessage={showInfoMessage}
            />
        </div>
    );
});

const baseFilterConfig = {
    "PT": {
        "slice": {
            "rows": [
                {
                    "uniqueName": "Área"
                },
                {
                    "uniqueName": "Programa"
                }
            ],
            "columns": [
                {
                    "uniqueName": "Data de Resposta.Year"
                },
                {
                    "uniqueName": "Data de Resposta.Month"
                },
                {
                    "uniqueName": "Measures"
                }
            ],
            "measures": [
                {
                    "uniqueName": "Valor da Resposta",
                    "aggregation": "average",
                    "format": "6u5nwcsu"
                }
            ],
            "expands": {
                "rows": [
                    {
                        "tuple": [
                            "Área.Nova Longa Duração"
                        ]
                    },
                    {
                        "tuple": [
                            "Área.Custom"
                        ]
                    }
                ],
                "columns": [
                    {
                        "tuple": [
                            "Data de Resposta.Year.2025"
                        ]
                    }
                ]
            }
        },
        "formats": [
            {
                "name": "6u5nwcsu",
                "thousandsSeparator": ",",
                "decimalSeparator": ",",
                "decimalPlaces": 1,
                "currencySymbol": "",
                "currencySymbolAlign": "left",
                "nullValue": "",
                "textAlign": "right",
                "isPercent": false
            }
        ]
    },
    "EN": {
        "slice": {
            "rows": [
                {
                    "uniqueName": "Área"
                },
                {
                    "uniqueName": "Programa"
                }
            ],
            "columns": [
                {
                    "uniqueName": "Data de Resposta.Year"
                },
                {
                    "uniqueName": "Data de Resposta.Month"
                },
                {
                    "uniqueName": "Measures"
                }
            ],
            "measures": [
                {
                    "uniqueName": "Valor da Resposta",
                    "aggregation": "average",
                    "format": "6u5nwcsu"
                }
            ],
            "expands": {
                "rows": [
                    {
                        "tuple": [
                            "Área.Nova Longa Duração"
                        ]
                    },
                    {
                        "tuple": [
                            "Área.Custom"
                        ]
                    }
                ],
                "columns": [
                    {
                        "tuple": [
                            "Data de Resposta.Year.2025"
                        ]
                    }
                ]
            }
        },
        "formats": [
            {
                "name": "6u5nwcsu",
                "thousandsSeparator": ",",
                "decimalSeparator": ",",
                "decimalPlaces": 1,
                "currencySymbol": "",
                "currencySymbolAlign": "left",
                "nullValue": "",
                "textAlign": "right",
                "isPercent": false
            }
        ]
    },
    "ES": {
        "slice": {
            "rows": [
                {
                    "uniqueName": "Área"
                },
                {
                    "uniqueName": "Programa"
                }
            ],
            "columns": [
                {
                    "uniqueName": "Data de Resposta.Year"
                },
                {
                    "uniqueName": "Data de Resposta.Month"
                },
                {
                    "uniqueName": "Measures"
                }
            ],
            "measures": [
                {
                    "uniqueName": "Valor da Resposta",
                    "aggregation": "average",
                    "format": "6u5nwcsu"
                }
            ],
            "expands": {
                "rows": [
                    {
                        "tuple": [
                            "Área.Nova Longa Duração"
                        ]
                    },
                    {
                        "tuple": [
                            "Área.Custom"
                        ]
                    }
                ],
                "columns": [
                    {
                        "tuple": [
                            "Data de Resposta.Year.2025"
                        ]
                    }
                ]
            }
        },
        "formats": [
            {
                "name": "6u5nwcsu",
                "thousandsSeparator": ",",
                "decimalSeparator": ",",
                "decimalPlaces": 1,
                "currencySymbol": "",
                "currencySymbolAlign": "left",
                "nullValue": "",
                "textAlign": "right",
                "isPercent": false
            }
        ]
    }
};
     
export const Report_6_Page = () => {
    const navigate                                              = useNavigate();
    const [ searchMetaParam,    setSearchMetaParam          ]   = useState(null);
    const [ searchParam,        setSearchParam              ]   = useState(blank_search_param_obj);
    const [ pivotRowData,       setPivotRowData             ]   = useState(null);
    const [ tableRowData,       setTableRowData             ]   = useState([]);
    const [ leftOpen,           setLeftOpen                 ]   = useState(true);

    const [ expandedDrawer,     setExpandedDrawer           ]   = useState(false);

    const [ pivotTableConfig,    setPivotTableConfig        ]   = useState(baseFilterConfig);
    const [ filterDataList,      setFilterDataList          ]   = useState(blank_filter_param_list);
    const [ filterObj,           setFilterObj               ]   = useState(blank_filter_param_obj);

    const { showLoader,          hideLoader                 }   = useLoader();
    const { showInfoMessage                                 }   = useInfoMsgModal();
    const { showActionMessage                               }   = useActionModal(); 
    const { showToastMessage                                }   = useToastMessage();

    const defaultCol = [
        {
            headerName: GetLabel(appLang, 610),
            marryChildren: true,
            children: [       
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 207),   field: "QUESTION_DESC"       , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 234),   field: "QUESTION_TYPE_DESC"  , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 249),   field: "QUESTION_LBL_DESC"   , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },
        {
            headerName: GetLabel(appLang, 611),
            marryChildren: true,
            children: [       
                { headerName: GetLabel(appLang, 604),   field: "ANSWER_VALUE"        , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: GetLabel(appLang, 603),   field: 'SUBMISSION_DT'       , filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 602),   field: 'SESSION_ORDER'       , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 376),   field: "OBSERVATION"         , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 605),   field: "OPT"                 , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 606),   field: "OPTION_VALUE"        , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                  
            ]
        },        
        {
            headerName: GetLabel(appLang, 573),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 600),  field: "ORDER_DESC"      , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 318),  field: "SCHOOL_DESC"     , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 319),  field: "AREA_DESC"       , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 322),  field: "CLIENT_DESC"     , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 321),  field: "PROGRAM_DESC"    , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 564),  field: "CLASS"           , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 388)    , field: 'OPENING', filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 389)    , field: 'CLOSING', filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },
        {
            headerName: GetLabel(appLang, 609),
            marryChildren: true,
            children: [       
                { headerName: GetLabel(appLang, 323),   field: "ACADEMIC_AREA_DESC"  , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 601),   field: "EVOLVEDS"            , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },        
    ].filter(Boolean);
    
    useEffect(() => {
        if (!Heimdall([23])) {
            navigate('/home');
        }
        else {
            SetLastFeature(23);
        }
        //  Get information about the filters and get user templates        
        const fetchFilterData = async () => {
            let data = await getFilterMeta();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setSearchMetaParam(data);
                }
                else {
                    setSearchMetaParam(blank_meta_param_obj);
                }
            }
            else {
                setSearchMetaParam(blank_meta_param_obj);
            }
        };
        const fetchPivotConfigTemplate = async () => {
            let data = await getPivotConfigTemplate();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setFilterDataList(data);
                }
            }
        };        
        fetchFilterData();
        fetchPivotConfigTemplate();
    }, []);
    
    async function RefreshUserFilter() {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await getPivotConfigTemplate();
        if (fetchedData && fetchedData?.status?.statusCode == 0) {
            fetchedData = fetchedData.response.content;
            setFilterDataList((prev) => ({
                ...prev,
                PERSONAL: fetchedData.PERSONAL,
                PUBLIC: fetchedData.PUBLIC,

            }));
            hideLoader();
            showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468)});
        }
        else {
            hideLoader();
            showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
        }
    };
    async function UpdatePivotUserFilter(filterData) {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await updatePivotConfigTemplate(filterData);
        if (fetchedData && fetchedData?.status?.statusCode == 0) {        
            setFilterObj(filterData);             
            hideLoader();
            showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468)});
            RefreshUserFilter(); 
        } 
        else {
            hideLoader();
            showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData?.status?.message});
        }
    };
    async function DeletePivotUserFilter(filterData) {
        let fetchedData = await deletePivotConfigTemplate(filterData);
        if (fetchedData && fetchedData?.status?.statusCode == 0) {
            hideLoader();
            showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468)});
            RefreshUserFilter();
        }
        else {
            hideLoader();
            showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
        }            
    };

    return (
        <React.Fragment>
            <DefaultPadding/>
            <div style={{ display: "flex", width: "100%" }}>
                <div
                    style={{
                        width: leftOpen ? "300px" : "4.5rem",
                        transition: "width 300ms ease-in-out",
                        overflow: "hidden",
                        minWidth: leftOpen ? "10%" : "0%",
                    }}
                >
                    <DrawerX 
                        expanded={leftOpen}
                        onToggle={() => setLeftOpen(prev => !prev)}
                    >
                        {leftOpen && (
                            <ExportData
                                type={2}
                                searchMetaParam={searchMetaParam}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                setPivotRowData={setPivotRowData}
                                setTableRowData={setTableRowData}
                                setExpandedDrawer={setExpandedDrawer}
                            />
                        )}
                    </DrawerX>
                </div>
                <div
                    style={{
                        flex: 1,
                        transition: "all 300ms ease-in-out",
                        minWidth: "70%",
                    }}
                >
                    <div className={[MainStyle.mx_3].join(" ")}>
                        <DrawerY 
                            defaultExpanded={expandedDrawer} 
                            objProp={{
                                drawerLabel: GetLabel(appLang, 607),
                                customColor: "blue"
                            }}
                        >
                            <PivotTable 
                                configData={pivotTableConfig}
                                setConfigData={setPivotTableConfig}
                                rawData={pivotRowData}
                                filterObj={filterObj}
                                setFilterObj={setFilterObj}
                                filterDataList={filterDataList}
                                refreshControl={RefreshUserFilter}
                                actionUpdateFilter={UpdatePivotUserFilter}
                                actionDeleteFilter={DeletePivotUserFilter}
                            />
                        </DrawerY>
                    </div>           
                    <DefaultPadding/>         
                    <div className={[MainStyle.mx_3].join(" ")}>
                        <DrawerY 
                            defaultExpanded={false} 
                            objProp={{
                                drawerLabel: GetLabel(appLang, 604),
                                customColor: "blue"
                            }}
                        >
                            <GenericGrid rowData={tableRowData} defsColumn={defaultCol}/>
                        </DrawerY>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export const Report_7_Page = () => {
    const navigate                                              = useNavigate();
    const [ searchMetaParam,    setSearchMetaParam          ]   = useState(null);
    const [ searchParam,        setSearchParam              ]   = useState(blank_search_param_obj);
    const [ pivotRowData,       setPivotRowData             ]   = useState(null);
    const [ tableRowData,       setTableRowData             ]   = useState([]);
    const [ leftOpen,           setLeftOpen                 ]   = useState(true);

    const [ expandedDrawer,     setExpandedDrawer           ]   = useState(false);

    const [ pivotTableConfig,    setPivotTableConfig        ]   = useState(baseFilterConfig);
    const [ filterDataList,      setFilterDataList          ]   = useState(blank_filter_param_list);
    const [ filterObj,           setFilterObj               ]   = useState(blank_filter_param_obj);

    const { showLoader,          hideLoader                 }   = useLoader();
    const { showInfoMessage                                 }   = useInfoMsgModal();
    const { showActionMessage                               }   = useActionModal(); 
    const { showToastMessage                                }   = useToastMessage();

    const defaultCol = [
        {
            headerName: GetLabel(appLang, 610),
            marryChildren: true,
            children: [       
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 207),   field: "QUESTION_DESC"       , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 234),   field: "QUESTION_TYPE_DESC"  , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 249),   field: "QUESTION_LBL_DESC"   , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },
        {
            headerName: GetLabel(appLang, 611),
            marryChildren: true,
            children: [       
                { headerName: GetLabel(appLang, 604),   field: "ANSWER_VALUE"        , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: GetLabel(appLang, 603),   field: 'SUBMISSION_DT'       , filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 602),   field: 'SESSION_ORDER'       , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 376),   field: "OBSERVATION"         , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 605),   field: "OPT"                 , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 606),   field: "OPTION_VALUE"        , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                  
            ]
        },        
        {
            headerName: GetLabel(appLang, 573),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 600),  field: "ORDER_DESC"      , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 318),  field: "SCHOOL_DESC"     , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 319),  field: "AREA_DESC"       , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 322),  field: "CLIENT_DESC"     , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 321),  field: "PROGRAM_DESC"    , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 564),  field: "CLASS"           , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 388)    , field: 'OPENING', filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 389)    , field: 'CLOSING', filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },
        {
            headerName: GetLabel(appLang, 609),
            marryChildren: true,
            children: [       
                { headerName: GetLabel(appLang, 323),   field: "ACADEMIC_AREA_DESC"  , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 601),   field: "EVOLVEDS"            , filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },        
    ].filter(Boolean);
    
    useEffect(() => {
        if (!Heimdall([24])) {
            navigate('/home');
        }
        else {
            SetLastFeature(24);
        }
        //  Get information about the filters and get user templates        
        const fetchFilterData = async () => {
            let data = await rgetFilterMeta();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setSearchMetaParam(data);
                }
                else {
                    setSearchMetaParam(blank_meta_param_obj);
                }
            }
            else {
                setSearchMetaParam(blank_meta_param_obj);
            }
        };
        const fetchPivotConfigTemplate = async () => {
            let data = await getPivotConfigTemplate();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setFilterDataList(data);
                }
            }
        };        
        fetchFilterData();
        fetchPivotConfigTemplate();
    }, []);
    
    async function RefreshUserFilter() {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await getPivotConfigTemplate();
        if (fetchedData && fetchedData?.status?.statusCode == 0) {
            fetchedData = fetchedData.response.content;
            setFilterDataList((prev) => ({
                ...prev,
                PERSONAL: fetchedData.PERSONAL,
                PUBLIC: fetchedData.PUBLIC,

            }));
            hideLoader();
            showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468)});
        }
        else {
            hideLoader();
            showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
        }
    };
    async function UpdatePivotUserFilter(filterData) {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await updatePivotConfigTemplate(filterData);
        if (fetchedData && fetchedData?.status?.statusCode == 0) {        
            setFilterObj(filterData);             
            hideLoader();
            showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468)});
            RefreshUserFilter(); 
        } 
        else {
            hideLoader();
            showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData?.status?.message});
        }
    };
    async function DeletePivotUserFilter(filterData) {
        let fetchedData = await deletePivotConfigTemplate(filterData);
        if (fetchedData && fetchedData?.status?.statusCode == 0) {
            hideLoader();
            showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468)});
            RefreshUserFilter();
        }
        else {
            hideLoader();
            showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
        }            
    };    

    return (
        <React.Fragment>
            <DefaultPadding/>
            <div style={{ display: "flex", width: "100%" }}>
                <div
                    style={{
                        width: leftOpen ? "300px" : "4.5rem",
                        transition: "width 300ms ease-in-out",
                        overflow: "hidden",
                        minWidth: leftOpen ? "10%" : "0%",
                    }}
                >
                    <DrawerX 
                        expanded={leftOpen}
                        onToggle={() => setLeftOpen(prev => !prev)}
                    >
                        {leftOpen && (
                            <ExportData 
                                type={2}
                                searchMetaParam={searchMetaParam}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                setPivotRowData={setPivotRowData}
                                setTableRowData={setTableRowData}
                                setExpandedDrawer={setExpandedDrawer}
                            />
                        )}
                    </DrawerX>
                </div>
                <div
                    style={{
                        flex: 1,
                        transition: "all 300ms ease-in-out",
                        minWidth: "70%",
                    }}
                >
                    <div className={[MainStyle.mx_3].join(" ")}>
                        <DrawerY 
                            defaultExpanded={expandedDrawer} 
                            objProp={{
                                drawerLabel: GetLabel(appLang, 607),
                                customColor: "blue"
                            }}
                        >
                            <PivotTable 
                                configData={pivotTableConfig}
                                setConfigData={setPivotTableConfig}
                                rawData={pivotRowData}
                                filterObj={filterObj}
                                setFilterObj={setFilterObj}
                                filterDataList={filterDataList}
                                refreshControl={RefreshUserFilter}
                                actionUpdateFilter={UpdatePivotUserFilter}
                                actionDeleteFilter={DeletePivotUserFilter}
                            />
                        </DrawerY>
                    </div>           
                    <DefaultPadding/>         
                    <div className={[MainStyle.mx_3].join(" ")}>
                        <DrawerY 
                            defaultExpanded={false} 
                            objProp={{
                                drawerLabel: GetLabel(appLang, 604),
                                customColor: "blue"
                            }}
                        >
                            <GenericGrid rowData={tableRowData} defsColumn={defaultCol}/>
                        </DrawerY>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};